<template>
  <v-row align="center" class="fill-height" justify="center">
    <v-col cols="12" lg="6" md="8" sm="10" xl="4">
      <LoginForm />
    </v-col>
  </v-row>
</template>

<script>
import LoginForm from '@/components/LoginForm'

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
}
</script>
